/**
  This module handle form generation, population, submission, error handling
*/
import mapValues from 'lodash/mapValues'

export default {
    data() {
      return {
        sending: false,
        form: {
          search: ''
        },
        data: '',
        dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          item: {name: '', email: '', mobile: ''}
        },
        table: {
          headers: [
            { label: 'ID', key: 'id' },
            { label: 'Nama', key: 'name' },
            { label: 'Tindakan', key: 'action', align: 'center' }
          ],
          items: [
            
          ],
          keyword: '',
          keywordFilter: keyword => item => {
            // Concatenate all the columns into a single string for a faster lookup.
            const allTheColumns = `${item.id} ${item.name} ${item.email}`

            // Lookup the keyword variable in the string with case-insensitive flag.
            return new RegExp(keyword, 'i').test(allTheColumns)
          },
          meta: [
            {last_page: 1}
          ]
        },
        validators: {
          required: value => !!value || 'Medan Ini Wajib Isi',
          numeric: value => !isNaN(value) || 'Medan Ini Wajib Numeric',
          email: value => {
            if(value) {

              return String(value)
                .toLowerCase()
                .match(
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                ) || 'Emel dimasukkan tidak benar';
            }
          },
          // Other validators...
          regex: value => {
            const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#_\$%\^&\*])/i
            return pattern.test(value) || 'Medan Ini Wajib mempunyai huruf besar, huruf kecil, nombor dan simbol'
          },
          min8: value => {
            return value.length >= 8 || 'Medan Ini Minimum 8 aksara'
          },
        }
      }
    },

    methods: {


        me(opts) {
            // foreign_key =
            // this.comp = opts.comp;
            // console.log('constructorion')
            // console.log(this.comp);
        },

        newrecord() {
            this.form = mapValues(this.form, () => null)
            this.dialog.show = true
            // $('#' + this.resourceurl).modal('show')
            this.form.saveButton = "Simpan"
        },

        edit(idx) {
            this.data = idx
            this.form = mapValues(this.form, function (v, x) {
                // console.log();
                return idx[x];
            })

            this.form.saveButton = "Kemaskini"
            this.dialog.show = true
        },
    
        submit() {
            // if (this.$refs.form.validate()) {
                this.dialog.loading = true

                if (this.form.id > 0) {
                    this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                        .then(res => {
                            //update displayed record
                            this.mapreturneddata(res)
                            this.dialog.show = false;
                          if (typeof this.onAfterEdit === "function") {
                              this.onAfterEdit()
                            }
                        })
                        .catch(err => {

                        })
                        .finally(() => {
                            this.dialog.loading = false
                            // this.dialog.show = false

                        });
                }
                else {
                    this.$zcomm.add(this.resourceurl + '.store', this.form)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          if(this.reload) {
                            this.$inertia.visit(this.$page.url)
                          }
                        })
                        .finally(() => {
                            this.dialog.loading = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });
                }
            // }
        },
        destroy(idx) {
            this.form.id = idx.id
            if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
                this.$zcomm.delete(this.resourceurl + '.destroy', this.form.id)
                    .then(res => {
                      //update displayed record
                      this.sending = false;
                      this.dialog.show = false;
                      this.removeitem(res) // remove the data from list. no need to refresh page
                      if (typeof this.onAfterDelete === "function") {
                        this.onAfterDelete()
                      }
                    })
                    .finally(() => {
                      // $('#' + this.resourceurl).modal('hide')
                    });
            }
        },
        success () {
          // this.loading = true
          // setTimeout(() => (this.loading = false), 3000)
        },
        mapreturneddata(res)
        {
          if(this.table.items.find(x => x.id == res.id)) {
            Object.assign(this.table.items.find(x => x.id == res.id),res)
          }
        },
        findItem(res, id)
        {
          return res.id == id;
        },
        removeitem(res)
        {
          if(this.table.items.find(x => x.id == res.id)) {
            this.table.items.splice(this.table.items.findIndex(this.findItem, res.id), 1);
          }
        },
        clearForm(form) {
            let vm = this

            return mapValues(form, function (v, x) {
              if (form[x] instanceof Array || form[x] instanceof Object) {
                  return vm.clearForm(form[x])
              } else {
                  return null;
              }
            })
        },

        mapForm(form, data) {
          return mapValues(form, function (v, x) {
                return data[x];
            })
        }

  },
  watch: {
    items: {
      handler () {
        // console.log(this.employees)
        this.table.headers = this.items.data.headers
        this.table.items = this.items.data.items
        this.table.meta = this.items.meta

      },
      deep: true,
    }
  },
  mounted() {
      if(this.items) {
        this.table.headers = this.items.data.headers
        this.table.items = this.items.data.items
        this.table.meta = this.items.meta
      }
    console.log('super mounted');
  },
  
      
  
}
